import Vue from 'vue';
import CustomerReviews from './CustomerReviews.vue';
import PaymentForm from './PaymentForm.vue';
import SubscriptionPlan from './SubscriptionPlan.vue';
import TrainingSwiper from './TrainingSwiper.vue';
import Ratings from './Ratings.vue';
import Retrospective from './Retrospective.vue';

Vue.component('subscriptions-plan', SubscriptionPlan)
Vue.component('subscriptions-payment-form', PaymentForm)
Vue.component('subscriptions-customer-reviews', CustomerReviews)
Vue.component('subscriptions-training-swiper', TrainingSwiper)
Vue.component('subscriptions-ratings', Ratings)
Vue.component('subscriptions-retrospective', Retrospective)
